import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { TStore } from '../store';

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { userToken } = useSelector((state: TStore) => state.user);

  // Simple check - if no token, redirect immediately
  // Axios interceptor will handle invalid/expired tokens via API calls
  if (!userToken) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
